class Zepter_V2_ZepterWorld_Tabs {
    constructor() {
        this.container = document.getElementById("V2_ZepterWorld_Tabs_Container");
        this.firstRun = true;
        this.disabled = false;
        this.bpMobile = 992; // (md)
        this.tabsCount = 0;
        this.currentTabIndex = 0;
        this.autoOpen = true;
        this.isFirstTab = true;
        this.isLastTab = false;
        // Jeśli brakuje kontenera
        if (!this.container) {
            // Przerwij działanie tej klasy
            return;
        }
        // Obsługa ikonki koszyka
        this.TabsController();
        // Usuń przebieg prierwszego wywołania klasy
        this.firstRun = false;
    }
    TabsController() {
        // Ustal element zawierający taby
        const elTabsList = document.getElementById("V2_ZepterWorld_Tabs_List");
        // Jesli element z tabami istnieje
        if (elTabsList) {
            // Ustal ilość tabów
            this.tabsCount = elTabsList.getElementsByClassName("V2_ZepterWorld_Tabs_Tab_Wrapper").length;
            // Zawsze ustaw ponownie pasek zakładek po zmianie rozmiaru okienka
            window.addEventListener("resize", () => { this.GoToTab(this.currentTabIndex); });
            // Przetwarzaj taby
            elTabsList.querySelectorAll("li").forEach((elTab, tabIndex) => {
                const linkElements = elTab.getElementsByClassName("V2_ZepterWorld_Tabs_Tab_Link");
                if (!linkElements || linkElements.length !== 1) {
                    console.error(`Expected one link. Found: ${linkElements.length}`);
                }
                else {
                    const link = linkElements[0];
                    link.onclick = () => {
                        // get href from attribute value, not from link.href as they are different. 
                        // Wwe use this value later on as $ selector.
                        const url = link.getAttribute("href");
                        this.fetchAndRenderDetail(url);
                        return false;
                    };
                }
                if (elTab.nodeType === 1) {
                    // Jeśli ten tab jest aktualnie wybrany
                    if (elTab.getElementsByClassName("V2_ZepterWorld_Tabs_Tab_Link_Selected").length === 1) {
                        // Przesuń slider do tego taba
                        this.GoToTab(tabIndex);
                    }
                }
            });
            // Uruchom działanie strzałek zmieniających taby
            this.ArrowsController();
        }
    }
    GoToTab(tabIndex) {
        // Debug
        //console.log(`Go to tab ${tabIndex} of ${this.tabsCount}`)
        var _a, _b, _c, _d, _e;
        // Ustal element z wrapperem zawierający taby
        const elTabsWrapper = document.getElementById("V2_ZepterWorld_Tabs_Wrapper");
        const elTabsList = document.getElementById("V2_ZepterWorld_Tabs_List");
        // Jeśli element zawierający taby istnieje
        if (elTabsWrapper && elTabsList) {
            // Nie pozwalaj na zmianę zakładki jeśli osiągnięta pierwszą/ostatnią zakładkę
            if (tabIndex < 0 || tabIndex >= this.tabsCount) {
                return;
            }
            // Zaktualizuj indeks wybranej zakładki
            this.currentTabIndex = tabIndex;
            // Ustaw pozycję zakładek we wrapperze (scrolluj do wybranej)
            elTabsList.style.left = `-${elTabsWrapper.offsetWidth * tabIndex}px`;
            // Ustal czy to jest pierwsza zakładka
            this.isFirstTab = tabIndex == 0 ? true : false;
            this.isLastTab = tabIndex == this.tabsCount - 1 ? true : false;
            // Zablokuj/odblokuj strzałkę [prev]
            if (this.isFirstTab) {
                (_a = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Prev_Wrapper")) === null || _a === void 0 ? void 0 : _a.classList.add("V2_ZepterWorld_Tabs_Arrow_Prev_Wrapper_Disabled");
            }
            else {
                (_b = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Prev_Wrapper")) === null || _b === void 0 ? void 0 : _b.classList.remove("V2_ZepterWorld_Tabs_Arrow_Prev_Wrapper_Disabled");
            }
            // Zablokuj/odblokuj strzałkę [next]
            if (this.isLastTab) {
                (_c = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Next_Wrapper")) === null || _c === void 0 ? void 0 : _c.classList.add("V2_ZepterWorld_Tabs_Arrow_Next_Wrapper_Disabled");
            }
            else {
                (_d = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Next_Wrapper")) === null || _d === void 0 ? void 0 : _d.classList.remove("V2_ZepterWorld_Tabs_Arrow_Next_Wrapper_Disabled");
            }
            // Jeśli aktywna jest funkcja autoOpen
            if (this.autoOpen && !this.firstRun) {
                const link = (_e = elTabsList.getElementsByClassName("V2_ZepterWorld_Tabs_Tab_Link")) === null || _e === void 0 ? void 0 : _e.item(tabIndex);
                const hrefUrl = link.getAttribute("href");
                // Jeśli link istnieje
                if (typeof hrefUrl == 'string' && hrefUrl.length > 0) {
                    // Przejdź do adresu do któego kieruje wybrana zakładka
                    this.fetchAndRenderDetail(hrefUrl);
                }
            }
        }
    }
    ArrowsController() {
        // Ustal obiekty ze strzałkami
        const arrowPrev = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Prev_Wrapper");
        const arrowNext = document.getElementById("V2_ZepterWorld_Tabs_Arrow_Next_Wrapper");
        // Ustaw akcję dla strzałki [previous]
        arrowPrev === null || arrowPrev === void 0 ? void 0 : arrowPrev.addEventListener("click", () => {
            this.GoToTab(this.currentTabIndex - 1);
        });
        // Ustaw akcję dla strzałki [next]
        arrowNext === null || arrowNext === void 0 ? void 0 : arrowNext.addEventListener("click", () => {
            this.GoToTab(this.currentTabIndex + 1);
        });
    }
    Disable() {
        // Zablokuj działanie paska z zakładkami
        this.disabled = true;
        this.container.style.pointerEvents = "none";
    }
    Enable() {
        // Odblokuj działanie paska z zakładkami
        this.disabled = true;
        this.container.style.pointerEvents = "";
    }
    fetchAndRenderDetail(url) {
        const selectedTabLinkClassName = "V2_ZepterWorld_Tabs_Tab_Link_Selected";
        $(`a.${selectedTabLinkClassName}`).removeClass(selectedTabLinkClassName);
        $.ajax({
            url: `${url}?partial=true`,
            success: function (data) {
                $('div[data-V2_ZepterWorld_Tabs_Detail]').html(data);
                $(`a[href="${url}"]`).addClass(selectedTabLinkClassName);
                history.pushState("", "", url);
            }
        });
    }
}
new Zepter_V2_ZepterWorld_Tabs();
//# sourceMappingURL=ZepterWorld_Tabs.js.map